<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('inventoryList.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('inventoryList.pageTitle'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div class="ts-flex ts-items-center ts-space-x-3">
            <a-range-picker v-model="dateRange" :allowClear="false" format="DD-MM-YYYY" valueFormat="DD-MM-YYYY"
              style="width:200px" @change="fetchData()" />
            <ts-button @click.prevent="show_form_refresh = true">
              <i class="fas fa-sync"></i>
            </ts-button>
            <ts-button @click.prevent="refreshCurrentStock" :waiting="refreshing" outline color="info">
              {{ $t('inventoryList.refreshCurrentStock') }}
            </ts-button>
          </div>
          <div class="d-flex ts-space-x-3 ts-items-center">
            <a-select v-model="categoryId" showSearch mode="multiple" :placeholder="$t('inventoryList.category')"
              :options="product_categories" :maxTagTextLength="17" :maxTagCount="1" style="width:250px"></a-select>
            <ts-branch-filter :isPlaceholder="true" @filter="filterBranch"></ts-branch-filter>
            <ts-location-filter @filter="filterLocaton"></ts-location-filter>
            <ts-input v-model="search" v-tooltip="$t('inventoryList.search')" :placeholder="$t('search')"
              style="width: 250px;" class="inline-block" />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-loading-banner :loading="loading">
        <div class="overflow-auto">
          <ts-table :records="resources">
            <template v-slot:thead>
              <tr>
                <th rowspan="2"
                  class="ts-uppercase ts-bg-gray-200 ts-align-middle ts-border-r ts-border-gray-500 ts-whitespace-no-wrap">
                  {{ $t('inventoryList.branchName') }}</th>
                <th rowspan="2" class="ts-uppercase ts-bg-gray-200 ts-border-r ts-border-gray-500">{{
        $t('inventoryList.location') }}</th>
                <th rowspan="2" class="ts-uppercase ts-bg-gray-200 ts-align-middle ts-border-r ts-border-gray-500">{{
        $t('inventoryList.barcode') }}</th>
                <th rowspan="2" class="ts-uppercase ts-bg-gray-200 ts-border-r ts-border-gray-500">{{
        $t('inventoryList.category') }}</th>
                <th rowspan="2"
                  class="ts-uppercase ts-bg-gray-200 ts-border-r ts-border-gray-500 ts-whitespace-no-wrap ">{{
        $t('inventoryList.productGroup') }}</th>
                <th rowspan="2" class="ts-uppercase ts-bg-gray-200 ts-border-r ts-border-gray-500">{{
        $t('inventoryList.description') }}</th>
                <!-- <th rowspan="2" class="ts-uppercase ts-bg-gray-200 ts-border-r ts-border-gray-500">
                  <p class="ts-mb-0">{{ $t('inventoryList.price')}}</p>
                  <p class="ts-mb-0 ts-text-center ts-text-red-600">USD</p>
                </th> -->
                <th rowspan="2" class="ts-uppercase ts-bg-gray-200 ts-border-r ts-border-gray-500">{{
        $t('inventoryList.begin') }}</th>
                <th colspan="6" class="ts-uppercase ts-bg-gray-200 ts-text-center ts-border ts-border-gray-500">{{
        $t('inventoryList.in') }}</th>
                <th colspan="7" class="ts-uppercase ts-bg-gray-200 ts-text-center ts-border ts-border-gray-500">{{
        $t('inventoryList.out') }}</th>
                <th rowspan="2" class="ts-uppercase ts-bg-gray-200 ts-border-r ts-border-gray-500">{{
        $t('inventoryList.ending') }}</th>
                <!-- <th rowspan="2" class="ts-uppercase ts-bg-gray-200 ts-border-r ts-border-gray-500">{{ $t('inventoryList.uom') }}</th> -->
                <!-- <th rowspan="2" class="ts-uppercase ts-bg-gray-200 ts-whitespace-no-wrap">
                  <p class="ts-mb-0">{{ $t('inventoryList.priceAmount')}}</p>
                  <p class="ts-mb-0 ts-text-center ts-text-red-600">USD</p>
                </th> -->
              </tr>
              <tr>
                <!-- column merge in -->
                <th class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-l ts-border-gray-500">{{
        $t('inventoryList.stock') }}</th>
                <th class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-gray-500">{{
        $t('inventoryList.transfer') }}</th>
                <th class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-gray-500">{{
        $t('inventoryList.adjustment') }}</th>
                <th
                  class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-gray-500 ts-whitespace-no-wrap">
                  {{ $t('inventoryList.fromVendor') }}</th>
                <th
                  class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-gray-500 ts-whitespace-no-wrap">
                  {{ $t('inventoryList.returnCustomer') }}</th>
                <th class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-gray-500">{{
        $t('inventoryList.total') }}</th>

                <!-- column merge out -->
                <th class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-gray-500">{{
        $t('inventoryList.sale') }}</th>
                <th class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-gray-500">{{
        $t('inventoryList.transfer') }}</th>
                <th class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-gray-500">{{
        $t('inventoryList.adjustment') }}</th>
                <th
                  class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-gray-500 ts-whitespace-no-wrap">
                  {{ $t('inventoryList.toVendor') }}</th>
                <th
                  class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-gray-500 ts-whitespace-no-wrap">
                  {{ $t('inventoryList.writeOff') }}</th>
                <th
                  class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-gray-500 ts-whitespace-no-wrap">
                  {{ $t('inventoryList.spReplacement') }}</th>
                <th class="ts-bg-gray-200 ts-text-center ts-uppercase ts-border-r ts-border-gray-500">{{
        $t('inventoryList.total') }}</th>
              </tr>
            </template>

            <template v-slot="{ record }">
              <td>{{ record.branch_name_en }}</td>
              <td>{{ record.location_name }}</td>
              <td>{{ record.barcode }}</td>
              <td>{{ record.category }}</td>
              <td>{{ record.product_group }}</td>
              <td class="ts-whitespace-no-wrap">{{ record.product_name }}</td>
              <!-- <td>{{( record.sale_price ?  format_number(record.sale_price) : 0 ) }}</td> -->
              <td>{{ record.begining_balance }}</td>
              <td class="ts-text-center">{{ record.quantity_in ? record.quantity_in : '-' }}</td>
              <td class="ts-text-center">{{ record.trasnfer_in ? record.trasnfer_in : '-' }}</td>
              <td class="ts-text-center">{{ record.adjustment_in ? record.adjustment_in : '-' }}</td>
              <td class="ts-text-center">{{ record.return_from_vendor_in ? record.return_from_vendor_in : '-' }}</td>
              <td class="ts-text-center">{{ record.return_from_customer_in ? record.return_from_customer_in : '-' }}
              </td>
              <td class="ts-text-center">{{ record.total_in ? record.total_in : '-' }}</td>

              <td class="ts-text-center">{{ record.qauntity_out ? record.qauntity_out : '-' }}</td>
              <td class="ts-text-center">{{ record.transfer_out ? record.transfer_out : '-' }}</td>
              <td class="ts-text-center">{{ record.adjustment_out ? record.adjustment_out : '-' }}</td>
              <td class="ts-text-center">{{ record.return_to_vendor_out ? record.return_to_vendor_out : '-' }}</td>
              <td class="ts-text-center">{{ record.write_off_out ? record.write_off_out : '-' }}</td>
              <td class="ts-text-center">{{ record.sp_replacement_out ? record.sp_replacement_out : '-' }}</td>
              <td class="ts-text-center">{{ record.total_out ? record.total_out : '-' }}</td>

              <td>{{ record.ending_balance }}</td>
              <!-- <td>{{ record.uom_name }}</td> -->
              <!-- <td class="ts-text-right">{{ (record.price_amount ? format_number(record.price_amount) : 0 ) }}</td> -->
            </template>
          </ts-table>
        </div>
      </ts-loading-banner>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
    <a-modal v-model="show_form_refresh" :title="$t('inventoryList.refreshStock')" width="300px" :centered="true"
      @ok="onRefreshStock" :confirmLoading="refreshing">
      <a-date-picker v-model="model.date" format="DD-MM-YYYY" valueFormat="DD-MM-YYYY" :allowClear="false"
        class="ts-w-full">
      </a-date-picker>
    </a-modal>

  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import moment from 'moment'
export default {
  name: 'inventoryList',
  data() {
    return {
      refreshing: false,
      show_form_refresh: false,
      loading: false,
      model: {
        date: moment().format('DD-MM-YYYY')
      }
    }
  },
  created() {
    // this.fetchData()
    this.refreshDailyStock()
  },
  computed: {
    ...mapState('stock/inventoryList', ['resources', 'pagination', 'product_categories']),
    search: {
      get() {
        return this.$store.state.stock.inventoryList.search
      },
      set(newValue) {
        this.$store.commit('stock/inventoryList/SET_SEARCH', newValue)
        this.$store.commit('stock/inventoryList/RESET_CURRENT_PAGE')
      }
    },
    dateRange: {
      get() {
        return this.$store.state.stock.inventoryList.dateRange
      },
      set(newValue) {
        this.$store.commit('stock/inventoryList/SET_DATE_RANGE', newValue)
      }
    },
    categoryId: {
      get() {
        return this.$store.state.stock.inventoryList.category_id
      },
      set(newValue) {
        this.$store.commit('stock/inventoryList/SET_CATEGORY_ID', newValue)
      }
    },

    // columns() {
    //   return [
    //     { name: this.$t('inventoryList.barcode') },
    //     { name: this.$t('inventoryList.location') },
    //     { name: this.$t('inventoryList.description') },
    //     { name: this.$t('inventoryList.category') },
    //     { name: this.$t('inventoryList.price') },
    //     { name: this.$t('inventoryList.begin') },
    //     { name: this.$t('inventoryList.qtyIn') },
    //     { name: this.$t('inventoryList.qtyOut') },
    //     { name: this.$t('inventoryList.balance') },
    //     { name: this.$t('inventoryList.uom') },
    //     { name: this.$t('inventoryList.priceAmount') },
    //   ]
    // }
  },
  methods: {
    format_number(value) {
      return parseFloat(value).toFixed(2)
    },
    fetchCategory(attributes) {
      this.loading = true
      this.$store
        .dispatch('stock/inventoryList/getProductCategory', { ...attributes })
        .then(response => {

        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('stock/inventoryList/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    filterLocaton(value) {
      this.$store.commit('stock/inventoryList/SET_LOCATION_ID', value)
      this.fetchData()
    },
    filterBranch(value) {
      this.$store.commit('stock/inventoryList/SET_BRANCH_ID', value)
      this.fetchData()
    },
    onRefreshStock() {
      this.refreshing = true
      this.$store
        .dispatch('stock/inventoryList/refreshStock', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.show_form_refresh = false
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.refreshing = false
        })
    },
    refreshCurrentStock() {
      this.refreshing = true
      this.$store
        .dispatch('stock/inventoryList/refreshCurrentStock')
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.refreshing = false
        })
    },
    refreshDailyStock() {
      this.refreshing = true
      this.$store
        .dispatch('stock/inventoryList/refreshDailyStock')
        .then(response => {
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.refreshing = false
        })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500),
    categoryId: debounce(function (search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchCategory()
    })
  }
}
</script>

<style scoped>
.table th {
  padding: 0.75rem;
  vertical-align: middle !important;
  border-top: 1px solid #d3d3d3;
}
</style>